/*! @pentacode/ui v0.1.0 */
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scale-input.js
function e(e, n) {
	let i = t(e), a = i ? e() : e;
	if (typeof a != "function" || typeof a.copy != "function" || typeof a.domain != "function" || typeof a.range != "function") throw TypeError("A scale factory must return a copyable scale with domain and range methods");
	let s = a.copy();
	if (i) {
		let e = r(s, n.values, n.includeZero);
		e && s.domain(e);
	}
	return o(s, n.nice, n.niceCount), s;
}
function t(e) {
	return typeof e == "function" && !("copy" in e);
}
function n(t, n) {
	if (!t) return;
	if (typeof t == "function") return t;
	let r = e(t.scale, {
		values: n,
		includeZero: !0,
		nice: t.nice,
		niceCount: 5
	});
	return (e) => r(e) ?? NaN;
}
function r(e, t, n = !1) {
	if (typeof e.bandwidth == "function" || typeof e.ticks != "function") {
		let e = [], n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
		for (let i of t) {
			if (!_(i)) continue;
			let t = i instanceof Date, a = t ? i.getTime() : i, o = t ? r : n;
			o.has(a) || (o.add(a), e.push(i));
		}
		return e.length ? e : void 0;
	}
	let r = t.filter(_);
	if (!r.length) return;
	if (e.domain().some((e) => e instanceof Date)) {
		let e = r.filter((e) => e instanceof Date);
		if (e.length !== r.length) throw TypeError("A temporal scale factory requires Date channel values");
		let t = Infinity, n = -Infinity;
		for (let r of e) {
			let e = r.getTime();
			t = Math.min(t, e), n = Math.max(n, e);
		}
		if (!Number.isFinite(t) || !Number.isFinite(n)) throw TypeError("A temporal scale factory requires Date channel values");
		if (t === n) {
			let e = 432e5;
			t -= e, n += e;
		}
		return [new Date(t), new Date(n)];
	}
	let o = Infinity, s = -Infinity;
	for (let e of r) {
		if (!v(e)) throw TypeError("A quantitative scale factory requires numeric values");
		o = Math.min(o, e), s = Math.max(s, e);
	}
	if (!Number.isFinite(o) || !Number.isFinite(s)) throw TypeError("A quantitative scale factory requires numeric values");
	let c = i(e);
	if (n) {
		if (c) throw TypeError("An inferred log scale cannot include an implicit zero baseline");
		o = Math.min(0, o), s = Math.max(0, s);
	}
	if (a(e, o, s), o === s) {
		if (o === 0) return [0, 1];
		let e = Math.abs(o) * .05 || 1;
		o -= e, s += e;
	}
	return [o, s];
}
function i(e) {
	return "base" in e && typeof e.base == "function";
}
function a(e, t, n) {
	if (i(e) && (t === 0 || n === 0 || t < 0 && n > 0)) throw TypeError("An inferred log domain cannot include or cross zero");
}
function o(e, t, n = 5) {
	if (!t) return;
	let r = e;
	if (typeof r.nice != "function") throw TypeError("This scale does not support nicening");
	r.nice(typeof t == "number" ? t : n);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales.js
function s(e, t, n) {
	if (t?.scale) {
		let r = u(t.scale), i = r ? t.scale() : t.scale;
		if (typeof i != "function" || typeof i.copy != "function") throw TypeError("A color scale must be callable and copyable");
		if (r && (typeof i.domain != "function" || typeof i.range != "function")) throw TypeError("A color scale factory must return a scale with domain and range methods");
		let a = i.copy(), o = m(a);
		if (r) {
			let n = a;
			t.range?.length && n.range(t.range);
			let r = t.domain ?? d(n, e);
			(t.domain !== void 0 || r.length) && n.domain(r);
			let i = n.range();
			if (!i.length || i.some((e) => typeof e != "string")) throw TypeError("A color-scale factory requires a string range");
		}
		if (t.nice) {
			let e = a.nice;
			if (typeof e != "function") throw TypeError("This color scale does not support nicening");
			e.call(a, typeof t.nice == "number" ? t.nice : 5);
		}
		let s = a.domain?.() ?? t.domain ?? [], c = (a.range?.() ?? t.range ?? n.palette).map(String);
		return {
			type: "configured",
			kind: o,
			domain: s,
			range: c,
			map: (e) => {
				if (e == null) return c[0] ?? "currentColor";
				let t = a(e);
				return t == null ? "currentColor" : String(t);
			}
		};
	}
	if (t?.resolver) return t.resolver.resolve({
		values: e,
		domain: t.domain,
		range: t.range,
		theme: n
	});
	let r = t?.range?.length ? t.range : n.palette, i = c(t?.domain ?? e), a = i.map(h);
	return {
		type: "ordinal",
		kind: "categorical",
		domain: i,
		range: r,
		map: (e) => {
			if (e == null) return r[0] ?? "currentColor";
			let t = a.indexOf(h(e));
			return t < 0 && (t = a.push(h(e)) - 1), r[t % r.length] ?? "currentColor";
		}
	};
}
function c(e) {
	return [...new Set(e.filter(l))];
}
function l(e) {
	return typeof e == "string" || typeof e == "number";
}
function u(e) {
	return typeof e == "function" && !("copy" in e);
}
function d(e, t) {
	let n = t.filter(l), r = e.quantiles, i = e.thresholds;
	if (r) return f(n);
	if (e.invertExtent && !i) throw TypeError("Threshold color-scale factory requires an explicit domain");
	if (e.ticks || i) {
		let t = f(n), r = Infinity, o = -Infinity;
		for (let e of t) r = Math.min(r, e), o = Math.max(o, e);
		if (!Number.isFinite(r) || !Number.isFinite(o)) return [];
		if (a(e, r, o), r === o) {
			if (r === 0) o = 1;
			else {
				let e = Math.abs(r) * .05 || 1;
				r -= e, o += e;
			}
		}
		if (i) return [r, o];
		let s = Math.max(2, e.domain().length, e.range().length);
		return Array.from({ length: s }, (e, t) => r + (o - r) * t / (s - 1));
	}
	return c(n);
}
function f(e) {
	let t = e.filter((e) => typeof e == "number" && Number.isFinite(e));
	return t.length !== e.length && p(), t;
}
function p() {
	throw TypeError("A quantitative color-scale factory requires numeric values");
}
function m(e) {
	return e.quantiles ? e.invertExtent ? "quantile" : "continuous" : e.thresholds ? "quantize" : e.invertExtent ? "threshold" : e.ticks ? "continuous" : "categorical";
}
function h(e) {
	return e instanceof Date ? `date:${e.getTime()}` : typeof e == "string" ? `string:${e.length}:${e}` : `${typeof e}:${String(e)}`;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/mark.js
var g = /* @__PURE__ */ new WeakSet();
function _(e) {
	return typeof e == "string" || e instanceof Date && Number.isFinite(e.getTime()) || v(e);
}
function v(e) {
	return typeof e == "number" && Number.isFinite(e);
}
function y(e) {
	return v(e) && e >= 0;
}
function b(e, t, n) {
	return {
		initialize: (r) => {
			let i = C(e(r)), a = t === void 0 || i.motion !== void 0 ? i : {
				...i,
				motion: t
			};
			return n === void 0 ? a : x(a, n);
		},
		...t === void 0 ? {} : { motion: t },
		...n === void 0 ? {} : { renderer: n }
	};
}
function x(e, t) {
	let n = e.render, r = e.resolveLayout;
	return {
		...e,
		render: (e) => S(n(e), t),
		...r ? { resolveLayout(e) {
			let n = r(e);
			return {
				...n,
				render: (e) => S(n.render(e), t)
			};
		} } : {}
	};
}
function S(e, t) {
	return {
		...e,
		nodes: e.nodes.map((e) => ({
			...e,
			renderer: t
		})),
		...e.focusGuides ? { focusGuides: e.focusGuides.map((e) => ({
			...e,
			renderer: t
		})) } : {}
	};
}
function C(e) {
	return typeof e.render == "function" ? e : {
		...e,
		render: () => {
			throw TypeError(`Mark "${e.id}" must resolve its layout before rendering`);
		}
	};
}
function w(e, t) {
	return t?.length ? {
		data: e,
		definitions: t
	} : void 0;
}
function T(e, t, n, r, i) {
	return typeof e == "function" ? e(t, {
		index: n,
		data: r
	}) : e ?? i;
}
function E(e, t, n) {
	return typeof t == "function" ? e.map((n, r) => t(n, {
		index: r,
		data: e
	})) : t === void 0 ? e.map((t, r) => n(t, {
		index: r,
		data: e
	})) : e.map((e) => typeof e == "object" && e ? e[t] : void 0);
}
function D(e, t, n = {}) {
	if (t !== void 0) return E(e, t, (e, { index: t }) => t);
	let r = [
		e.map((e) => typeof e == "object" && e ? e.id : void 0),
		e.map((e) => {
			if (typeof e != "object" || !e) return;
			let t = e.data;
			return typeof t == "object" && t ? t.id : void 0;
		}),
		...n.candidates ?? []
	];
	for (let t of r) {
		if (t.length !== e.length) continue;
		let r = t.map(k);
		if (r.every((e) => e !== void 0) && A(r, n.groups)) return r;
	}
	return j(n.markId, n.candidates, n.warningIdentity), e.map((e, t) => t);
}
function O(...e) {
	let t = e[0]?.length ?? 0;
	return Array.from({ length: t }, (t, n) => {
		let r = e.map((e) => k(e[n]));
		return r.every((e) => e !== void 0) ? JSON.stringify(r.map(h)) : void 0;
	});
}
function k(e) {
	if (l(e)) return e;
	if (e instanceof Date && Number.isFinite(e.getTime())) return `date:${e.getTime()}`;
}
function A(e, t) {
	let n = /* @__PURE__ */ new Set();
	for (let r = 0; r < e.length; r += 1) {
		let i = JSON.stringify([h(t?.[r] ?? null), h(e[r])]);
		if (n.has(i)) return !1;
		n.add(i);
	}
	return !0;
}
function j(e, t, n) {
	e && t?.length && n && !g.has(n) && typeof process < "u" && process.env.NODE_ENV !== "production" && (g.add(n), console.warn(`TanStack Charts could not infer a unique key for mark "${e}". Using row position; supply key for stable identity across updates.`));
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/guide-layout.js
var M = 16, N = 400, P = {
	fontFamily: "sans-serif",
	fontStyle: "normal",
	fontStretch: "normal",
	letterSpacing: 0,
	direction: "inherit",
	fontScale: 1
};
function F(e, t) {
	if (e === "middle") return "middle";
	let n = t !== "rtl";
	return e === "left" ? n ? "start" : "end" : n ? "end" : "start";
}
function I(e, t, n) {
	return t === "middle" ? -e / 2 : t === "start" == (n !== "rtl") ? 0 : -e;
}
function L(e, t) {
	let n = K(t.fontScale, 1), r = W(t.fontSize, M) * n, i = W(t.fontWeight, N), a = G(t.letterSpacing, 0) * n;
	if (!e || r === 0) return {
		x: 0,
		y: 0,
		width: 0,
		height: 0
	};
	let o = 0;
	for (let t of e) o += U(t);
	let s = 1 + (Math.min(900, Math.max(100, i)) - 400) / 12500, c = Math.max(0, o * r * s + Math.max(0, Array.from(e).length - 1) * a), l = r;
	return {
		x: I(c, t.anchor, t.direction),
		y: t.baseline === "middle" ? -l / 2 : t.baseline === "hanging" ? 0 : -r * .8,
		width: c,
		height: l
	};
}
function R(e, t = L) {
	let n = W(e.fontSize, M), r = e.anchor ?? "start", i = e.baseline ?? "auto", a = e.text.length === 0 ? {
		x: 0,
		y: 0,
		width: 0,
		height: 0
	} : t(e.text, {
		fontSize: n,
		fontWeight: e.fontWeight,
		...P,
		anchor: r,
		baseline: i
	}), o = G(a.x, 0), s = G(a.y, 0), c = W(a.width, 0), l = W(a.height, 0), u = {
		x: e.x + o,
		y: e.y + s,
		width: c,
		height: l
	};
	return e.rotate ? H(u, e.x, e.y, e.rotate) : u;
}
function z(e = L, t = {}) {
	let n = {
		...P,
		...t,
		fontFamily: t.fontFamily || P.fontFamily,
		fontStyle: t.fontStyle || P.fontStyle,
		fontStretch: t.fontStretch || P.fontStretch,
		letterSpacing: G(t.letterSpacing, 0),
		fontScale: K(t.fontScale, 1)
	};
	return (t, r) => e(t, {
		...r,
		...n
	});
}
function B(e, t, n) {
	V(t, 0, 0, (t, r, i) => {
		let a = t.style;
		if (!(a?.strokeWidth !== void 0 || a?.lineCap !== void 0 && a.lineCap !== "butt") || a?.stroke === "none") return;
		let o = a?.strokeWidth ?? 1;
		if (!Number.isFinite(o) || o <= 0) return;
		let s = o / 2, c = t.x1 + r, l = t.x2 + r, u = t.y1 + i, d = t.y2 + i, f = l - c, p = d - u, m = Math.hypot(f, p), h = m > 0 ? f / m : 0, g = m > 0 ? p / m : 0, _ = a?.lineCap && a.lineCap !== "butt" ? s : 0, v = Math.abs(g) * s + Math.abs(h) * _, y = Math.abs(h) * s + Math.abs(g) * _, b = Math.min(c, l) - v, x = Math.max(c, l) + v, S = Math.min(u, d) - y, C = Math.max(u, d) + y;
		e.top = Math.max(e.top, n.y - S), e.right = Math.max(e.right, x - n.x - n.width), e.bottom = Math.max(e.bottom, C - n.y - n.height), e.left = Math.max(e.left, n.x - b);
	});
}
function V(e, t, n, r) {
	if (e.kind === "rule") {
		r(e, t, n);
		return;
	}
	if (e.kind !== "group") return;
	let i = t + (e.translateX ?? 0), a = n + (e.translateY ?? 0);
	for (let t of e.children) V(t, i, a, r);
}
function H(e, t, n, r) {
	let i = r * Math.PI / 180, a = Math.cos(i), o = Math.sin(i), s = e.x + e.width / 2 - t, c = e.y + e.height / 2 - n, l = Math.abs(e.width * a) + Math.abs(e.height * o), u = Math.abs(e.width * o) + Math.abs(e.height * a), d = s * a - c * o + t, f = s * o + c * a + n;
	return {
		x: d - l / 2,
		y: f - u / 2,
		width: l,
		height: u
	};
}
function U(e) {
	return /\s/u.test(e) ? .33 : /[\u0300-\u036f]/u.test(e) ? 0 : /[ilI1|!.,:;'`]/u.test(e) ? .28 : /[mwMW@#%&]/u.test(e) ? .9 : /[A-Z]/u.test(e) ? .64 : /[0-9]/u.test(e) ? .56 : e.codePointAt(0) > 127 ? 1 : .54;
}
function W(e, t) {
	return e !== void 0 && Number.isFinite(e) && e >= 0 ? e : t;
}
function G(e, t) {
	return e !== void 0 && Number.isFinite(e) ? e : t;
}
function K(e, t) {
	return e !== void 0 && Number.isFinite(e) && e > 0 ? e : t;
}
//#endregion
export { n as C, i as S, C as _, F as a, l as b, S as c, b as d, D as f, w as g, y as h, R as i, E as l, v as m, B as n, z as o, _ as p, I as r, x as s, L as t, O as u, T as v, e as w, h as x, s as y };

//# sourceMappingURL=guide-layout-CrWsmVuf.js.map